<template>
  <div class="wrapper">
  <el-form ref="form" :model="form" label-width="80px">

    <el-form-item label="计划名称">
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="计划类型">
      <el-radio-group v-model="form.type" >
        <el-radio-button   label="1" ><img style="width:150px" src="@/assets/img/type1.png"/></el-radio-button>nbsp
        <el-radio-button    label="2" ><img style="width:150px"  src="@/assets/img/type2.png"/></el-radio-button>
      </el-radio-group>
      (创建后无法修改)
    </el-form-item>
    <el-form-item label="计划简介">
      <textarea style="width: 100%" v-model="form.remark"></textarea>
    </el-form-item>
    <el-form-item label="计划分类">
        <treeinput
            :questionTypeTree="planGroupTree"
            @treeEvent="treeEvent"
            :currentNodeId="form.groupId"
        ></treeinput>
    </el-form-item>
    <el-form-item label="指定学习">
      <el-input v-model="form.studentGroupIds"></el-input>
    </el-form-item>
    <el-form-item label="允许拖动进度条">
      <el-input v-model="form.canDrag"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="saveForm">保存</el-button>
    </el-form-item>


  </el-form>

  </div>
</template>
<script>
import mytree from "@/component/tree/mytree.vue";
import treeinput from "@/component/tree/treeInput.vue";
import {addPlan,selectTreeData,planDetail} from "@/api/learnplan";

export default {
  components: {mytree, treeinput,},
  props: {},
  data() {
    return {
      form: {
        groupId:0,
        id:"",
      },
      planGroupTree:[],
      temporaryTree: "",
      chooseGroupName:{},
    }

  },
  watch: {},
  computed:{},
  methods:{
    saveForm(){
      addPlan(this.form).then(
          (data) => {
            if (data.status){
              this.$Message.success("保存成功");
              this.$router.push({ name: "learnPlan", params: {} });
            }
          },
          (data) => {
            this.$Message.error(data || "错误");
          }
      );

    },
    pageInit() {
      let that = this;
      selectTreeData().then((data) => {
        data.data.forEach(function treeMaker(item) {
          item.expand = false;
          item.contextmenu = true;
          if (that.$route.query.id && item.id == that.form.groupId) {
            that.chooseGroupName = item;
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((nextItem) => treeMaker(nextItem));
          }
        });

        this.planGroupTree = data.data;
      });
    },
    treeEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameExaminationType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("修改成功");
                this.examinationTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );

          break;
        case "delete":
          deleteExaminationType({
            id: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("删除成功");
                this.examinationTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );
          break;
        case "append":
          appendExaminationType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("创建成功");
                this.examinationTypeInit();
              },
              (data) => {
                this.$Message.success(data || "创建失败");
              }
          );
          break;
        case "move":
          moveExaminationType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("移动成功");
                this.examinationTypeInit();
              },
              (data) => {
                this.$Message.success(data || "移动失败");
              }
          );
          break;
          // case "chosen":
          //   console.log(eventDetail);
          //   this.settingData.studentGroupChosen = eventDetail.value;
          //   break;
        case "select":
          this.temporaryTree = eventDetail.value;
          break;
        case "confirm":
          this.chooseGroupName = this.temporaryTree;
          this.form.groupId = this.temporaryTree.id;
          break;
        default:
          break;
      }
    },

  },
  created() {},
  mounted() {
     this.pageInit();
    let query = this.$route.query;
    console.log("请进",query);
    if (query!=null) {
      if (query.item.id) {
        this.form.id = query.item.id;
        planDetail({id: query.item.id}).then((data) => {
          this.form = data.data
        });

      }
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{

  .el-radio-button {
    margin-right: 15px;
    border-radius: 4px;

    //.type1{
    //  background: url("../src/assets/img/type1.png");
    //}
  }


}
</style>